export class HUD {
    constructor(player, evolutionSystem) {
        this.player = player;
        this.evolutionSystem = evolutionSystem;
        
        this.healthBar = document.getElementById('health-fill');
        this.essenceCounter = document.getElementById('essence-counter');
        this.evolutionInfo = document.getElementById('evolution-info');
        
        // Boss health bar elements
        this.bossHealthContainer = document.getElementById('boss-health-container');
        this.bossHealthFill = document.getElementById('boss-health-fill');
        this.bossName = document.getElementById('boss-name');
        
        this.shopOpen = false;
        this.controls = null;
        
        this.setupEvolutionShop();
        this.setupControlsGuide();
        this.setupEvolutionNotification();
        this.setupMushroomMessage();
        this.setupAbilityBoxes();
        this.setupBossIntro();
        this.setupKillCounter();
        this.setupReadyToEvolveNotification();
        
        this.hasShownReadyNotification = false;
    }
    
    setControls(controls) {
        this.controls = controls;
    }
    
    setGame(game) {
        this.game = game;
    }
    
    setupEvolutionShop() {
        // Create shop modal
        const shopModal = document.createElement('div');
        shopModal.id = 'evolution-shop';
        shopModal.style.cssText = `
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0, 0, 0, 0.95);
            border: 3px solid #00ffff;
            border-radius: 15px;
            padding: 30px;
            display: none;
            pointer-events: all;
            max-width: 600px;
            max-height: 80vh;
            overflow-y: auto;
            z-index: 2000;
            text-align: left;
            font-family: 'Courier New', monospace;
        `;
        document.getElementById('hud').appendChild(shopModal);
        
        // Toggle shop with ESC and T
        document.addEventListener('keydown', (e) => {
            // T key = Open/Close Evolution Shop (main upgrade menu)
            if (e.key.toLowerCase() === 't') {
                if (this.shopOpen) {
                    // Close shop
                    this.shopOpen = false;
                    shopModal.style.display = 'none';
                    // Switch to gameplay cursor
                    if (this.game) {
                        this.game.setCursorState('gameplay');
                        this.game.isPaused = false;
                    }
                    // Unpause and re-lock cursor synchronously (only if game started)
                    if (this.controls && !this.controls.isLocked && this.game && this.game.isGameStarted) {
                        this.controls.lock();
                    }
                } else {
                    // Open shop
                    this.shopOpen = true;
                    shopModal.style.display = 'block';
                    this.updateShop();
                    this.hasShownReadyNotification = false;
                    
                    // Hide evolution panel when menu is open
                    const evolutionPanel = document.getElementById('evolution-panel');
                    if (evolutionPanel) evolutionPanel.style.display = 'none';
                    
                    // Hide "Ready to Evolve" popup notification
                    // Hide evolution notification when menu opens
                    if (this.readyToEvolveNotification) {
                        this.readyToEvolveNotification.style.opacity = '0';
                        this.readyToEvolveNotification.style.transform = 'translateX(-50%) scale(0)';
                    }
                    
                    // Switch to menu cursor
                    if (this.game) {
                        this.game.setCursorState('menu');
                        this.game.isPaused = true;
                    }
                    // Pause and unlock cursor synchronously
                    if (this.controls && this.controls.isLocked) {
                        this.controls.unlock();
                    }
                }
            }
            
            // ESC key = Close any open menus (no toggle, just close)
            if (e.key === 'Escape') {
                if (this.shopOpen) {
                    // Close shop
                    this.shopOpen = false;
                    shopModal.style.display = 'none';
                    // Switch to gameplay cursor
                    if (this.game) {
                        this.game.setCursorState('gameplay');
                        this.game.isPaused = false;
                    }
                    // Unpause and re-lock cursor synchronously (only if game started)
                    if (this.controls && !this.controls.isLocked && this.game && this.game.isGameStarted) {
                        this.controls.lock();
                    }
                }
            }
        });
        
        // Click to recapture if not captured - BUT ONLY DURING GAMEPLAY
        document.addEventListener('click', () => {
            // CRITICAL: Never lock pointer before game starts!
            if (this.controls && !this.controls.isLocked && !this.shopOpen && 
                this.game && this.game.isGameStarted && !this.game.isPaused) {
                this.controls.lock();
            }
        });
        
        // Ensure cursor and pause state are always synchronized
        setInterval(() => {
            if (this.controls && this.game) {
                // CRITICAL: Only sync cursor AFTER game has started!
                if (this.game.isGameStarted) {
                    // If game is NOT paused but cursor is unlocked (bad state) - lock it
                    if (!this.game.isPaused && !this.shopOpen && !this.controls.isLocked) {
                        console.warn('Cursor desync detected - re-locking cursor');
                        this.controls.lock();
                    }
                }
                // If shop is open but cursor is locked (bad state) - unlock it
                if (this.shopOpen && this.controls.isLocked) {
                    console.warn('Shop cursor desync detected - unlocking cursor');
                    this.controls.unlock();
                }
            }
        }, 100); // Check every 100ms
        
        this.shopModal = shopModal;
    }
    
    setupControlsGuide() {
        const guide = document.createElement('div');
        guide.id = 'controls-guide';
        guide.style.cssText = `
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0, 0, 0, 0.8);
            border: 2px solid #00ff00;
            border-radius: 10px;
            padding: 15px 30px;
            color: #fff;
            font-size: 16px;
            text-align: center;
            pointer-events: none;
            font-family: 'Courier New', monospace;
        `;
        guide.innerHTML = `
            <div style="display: flex; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <span><strong>WASD</strong> Move</span>
                <span><strong>SPACE</strong> Jump</span>
                <span><strong>CLICK</strong> Shoot</span>
                <span><strong>Q/E</strong> Abilities</span>
                <span><strong>T</strong> Upgrades</span>
            </div>
        `;
        document.getElementById('hud').appendChild(guide);
    }
    
    setupEvolutionNotification() {
        const notification = document.createElement('div');
        notification.id = 'evolution-notification';
        notification.style.cssText = `
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            background: linear-gradient(135deg, #ff00ff, #00ffff);
            border: 5px solid #fff;
            border-radius: 20px;
            padding: 40px 60px;
            color: #fff;
            font-size: 48px;
            font-weight: bold;
            text-align: center;
            pointer-events: none;
            font-family: 'Courier New', monospace;
            text-shadow: 0 0 20px #000, 0 0 40px #000;
            box-shadow: 0 0 60px rgba(255, 0, 255, 0.8);
            transition: transform 0.3s ease, opacity 0.3s ease;
            opacity: 0;
            z-index: 1000;
        `;
        document.getElementById('hud').appendChild(notification);
        this.evolutionNotification = notification;
    }
    
    showEvolutionUnlocked(evolutionName, icon) {
        this.evolutionNotification.innerHTML = `
            <div style="font-size: 72px; margin-bottom: 20px;">${icon}</div>
            <div>EVOLVED!</div>
            <div style="font-size: 32px; margin-top: 15px; color: #ffff00;">${evolutionName}</div>
        `;
        
        this.evolutionNotification.style.opacity = '1';
        this.evolutionNotification.style.transform = 'translate(-50%, -50%) scale(1)';
        
        // Clear existing timeout if any
        if (this.evolutionNotificationTimeout) {
            clearTimeout(this.evolutionNotificationTimeout);
        }
        
        this.evolutionNotificationTimeout = setTimeout(() => {
            this.evolutionNotification.style.opacity = '0';
            this.evolutionNotification.style.transform = 'translate(-50%, -50%) scale(0)';
        }, 3000);
    }
    
    dismissEvolutionNotification() {
        // Immediately dismiss evolution notification
        if (this.evolutionNotificationTimeout) {
            clearTimeout(this.evolutionNotificationTimeout);
        }
        this.evolutionNotification.style.opacity = '0';
        this.evolutionNotification.style.transform = 'translate(-50%, -50%) scale(0)';
    }
    
    setupMushroomMessage() {
        const message = document.createElement('div');
        message.id = 'mushroom-message';
        message.style.cssText = `
            position: absolute;
            top: 20%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            background: rgba(0, 0, 0, 0.9);
            border: 3px solid #00ff00;
            border-radius: 15px;
            padding: 20px 40px;
            color: #00ff00;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            pointer-events: none;
            font-family: 'Courier New', monospace;
            box-shadow: 0 0 30px rgba(0, 255, 0, 0.6);
            transition: transform 0.3s ease, opacity 0.3s ease;
            opacity: 0;
            z-index: 999;
        `;
        document.getElementById('hud').appendChild(message);
        this.mushroomMessage = message;
    }
    
    showMushroomMessage(text) {
        this.mushroomMessage.textContent = text;
        this.mushroomMessage.style.opacity = '1';
        this.mushroomMessage.style.transform = 'translate(-50%, -50%) scale(1.2)';
        this.mushroomMessage.style.fontSize = '32px';
        
        // Bounce animation
        setTimeout(() => {
            this.mushroomMessage.style.transform = 'translate(-50%, -50%) scale(1)';
        }, 100);
        
        setTimeout(() => {
            this.mushroomMessage.style.opacity = '0';
            this.mushroomMessage.style.transform = 'translate(-50%, -50%) scale(0)';
            this.mushroomMessage.style.fontSize = '24px';
        }, 2500);
    }
    
    setupAbilityBoxes() {
        const container = document.createElement('div');
        container.style.cssText = `
            position: absolute;
            bottom: 20px;
            right: 20px;
            display: flex;
            gap: 15px;
            pointer-events: none;
        `;
        
        // Q Ability Box
        const qBox = document.createElement('div');
        qBox.id = 'ability-q';
        qBox.style.cssText = `
            width: 150px;
            height: 80px;
            background: rgba(0, 0, 0, 0.8);
            border: 2px solid #00ffff;
            border-radius: 10px;
            padding: 10px;
            color: #fff;
            font-family: 'Courier New', monospace;
            text-align: center;
        `;
        qBox.innerHTML = `
            <div style="font-size: 20px; font-weight: bold; color: #00ffff;">Q</div>
            <div id="ability-q-name" style="font-size: 14px; margin-top: 5px;">-</div>
            <div id="ability-q-desc" style="font-size: 10px; color: #888; margin-top: 3px;">No ability</div>
        `;
        
        // E Ability Box
        const eBox = document.createElement('div');
        eBox.id = 'ability-e';
        eBox.style.cssText = qBox.style.cssText;
        eBox.innerHTML = `
            <div style="font-size: 20px; font-weight: bold; color: #00ffff;">E</div>
            <div id="ability-e-name" style="font-size: 14px; margin-top: 5px;">-</div>
            <div id="ability-e-desc" style="font-size: 10px; color: #888; margin-top: 3px;">No ability</div>
        `;
        
        container.appendChild(qBox);
        container.appendChild(eBox);
        document.getElementById('hud').appendChild(container);
        
        this.abilityQName = document.getElementById('ability-q-name');
        this.abilityQDesc = document.getElementById('ability-q-desc');
        this.abilityEName = document.getElementById('ability-e-name');
        this.abilityEDesc = document.getElementById('ability-e-desc');
    }
    
    setupBossIntro() {
        const intro = document.createElement('div');
        intro.id = 'boss-intro';
        intro.style.cssText = `
            position: absolute;
            z-index: 1800;
            top: 15%;
            left: 50%;
            transform: translate(-50%, 0) scale(0);
            background: linear-gradient(135deg, #ff0000, #ff6b00);
            border: 5px solid #fff;
            border-radius: 20px;
            padding: 30px 60px;
            color: #fff;
            font-size: 48px;
            font-weight: bold;
            text-align: center;
            pointer-events: none;
            font-family: 'Courier New', monospace;
            text-shadow: 0 0 20px #000, 0 0 40px #000;
            box-shadow: 0 0 80px rgba(255, 0, 0, 0.9);
            transition: transform 0.4s ease, opacity 0.4s ease;
            opacity: 0;
            z-index: 1500;
        `;
        document.getElementById('hud').appendChild(intro);
        this.bossIntro = intro;
    }
    
    showBossIntro(bossName, bossNumber) {
        this.bossIntro.innerHTML = `
            <div class="boss-intro-bg" style="
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(135deg, #ff0000, #ff6b00);
                border-radius: 20px;
                transition: opacity 1.5s ease-out;
            "></div>
            <div class="boss-intro-content" style="position: relative; z-index: 1;">
                <div style="font-size: 32px; color: #ffff00; margin-bottom: 15px;">⚠️ BOSS ${bossNumber}/3 ⚠️</div>
                <div style="font-size: 64px; animation: glow 1s infinite;">${bossName}</div>
                <div style="font-size: 28px; color: #ffcccc; margin-top: 15px;">PREPARE FOR BATTLE!</div>
            </div>
        `;
        
        this.bossIntro.style.opacity = '1';
        this.bossIntro.style.transform = 'translate(-50%, 0) scale(1)';
        
        // Fade background immediately
        const bg = this.bossIntro.querySelector('.boss-intro-bg');
        setTimeout(() => {
            bg.style.opacity = '0';
        }, 100);
        
        // Hide entire element after text duration (reduced to 2 seconds)
        setTimeout(() => {
            this.bossIntro.style.opacity = '0';
            this.bossIntro.style.transform = 'translate(-50%, 0) scale(0)';
        }, 2000);
    }
    
    setupKillCounter() {
        const counter = document.createElement('div');
        counter.id = 'kill-counter';
        counter.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            background: rgba(0, 0, 0, 0.8);
            border: 3px solid #ff0000;
            border-radius: 10px;
            padding: 15px 20px;
            color: #fff;
            font-family: 'Courier New', monospace;
            font-size: 16px;
            text-align: right;
            min-width: 200px;
            box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
        `;
        counter.innerHTML = `
            <div style="font-size: 20px; font-weight: bold; color: #ff0000; margin-bottom: 5px;">💀 KILLS</div>
            <div id="kill-count" style="font-size: 32px; font-weight: bold; color: #fff;">0</div>
            <div id="next-boss" style="font-size: 14px; color: #ffff00; margin-top: 5px;">Next Boss: 10</div>
        `;
        document.getElementById('hud').appendChild(counter);
        
        this.killCountElement = document.getElementById('kill-count');
        this.nextBossElement = document.getElementById('next-boss');
    }
    
    setupReadyToEvolveNotification() {
        const notification = document.createElement('div');
        notification.id = 'ready-to-evolve';
        notification.style.cssText = `
            position: absolute;
            bottom: 120px;
            left: 50%;
            transform: translateX(-50%) scale(0);
            background: linear-gradient(135deg, #00ff00, #00ffff);
            border: 4px solid #fff;
            border-radius: 15px;
            padding: 20px 40px;
            color: #000;
            font-size: 28px;
            font-weight: bold;
            text-align: center;
            pointer-events: none;
            font-family: 'Courier New', monospace;
            text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 40px rgba(0, 255, 0, 0.9);
            transition: transform 0.3s ease, opacity 0.3s ease;
            opacity: 0;
            z-index: 1200;
        `;
        notification.innerHTML = `
            <div style="font-size: 36px; margin-bottom: 5px;">✨🧬✨</div>
            <div>READY TO EVOLVE!</div>
            <div style="font-size: 18px; margin-top: 5px; color: #003300;">Press T to upgrade immediately!</div>
        `;
        document.getElementById('hud').appendChild(notification);
        this.readyToEvolveNotification = notification;
    }
    
    showReadyToEvolve() {
        if (this.hasShownReadyNotification) return;
        
        this.readyToEvolveNotification.style.opacity = '1';
        this.readyToEvolveNotification.style.transform = 'translateX(-50%) scale(1)';
        
        // Play evolution ready sound
        if (this.game && this.game.audioManager) {
            this.game.audioManager.playEvolutionReady();
        }
        
        this.hasShownReadyNotification = true;
        
        setTimeout(() => {
            this.readyToEvolveNotification.style.opacity = '0';
            this.readyToEvolveNotification.style.transform = 'translateX(-50%) scale(0)';
        }, 4000);
    }
    
    updateShop() {
        const available = this.evolutionSystem.getAvailableEvolutions();
        const active = this.evolutionSystem.getActiveEvolutions();
        
        let html = '<h2 style="color: #00ffff; margin-bottom: 20px; text-align: center;">🧬 Evolution Shop</h2>';
        html += `<p style="color: #fff; margin-bottom: 20px; text-align: center;">Your Essence: ✨ ${this.player.essence}</p>`;
        
        if (active.length > 0) {
            html += '<h3 style="color: #00ff00; margin-top: 20px;">Active Evolutions:</h3>';
            html += '<div style="margin-bottom: 20px;">';
            active.forEach(evo => {
                html += `
                    <div style="padding: 10px; margin: 5px 0; background: rgba(0, 255, 0, 0.2); border-radius: 5px; color: #fff;">
                        ${evo.icon} ${evo.name} - ${evo.description}
                    </div>
                `;
            });
            html += '</div>';
        }
        
        if (available.length > 0) {
            html += '<h3 style="color: #ffff00; margin-top: 20px;">Available Evolutions:</h3>';
            available.forEach(evo => {
                const canAfford = this.evolutionSystem.canAfford(evo.id);
                const color = canAfford ? '#00ff00' : '#ff0000';
                
                html += `
                    <div style="padding: 15px; margin: 10px 0; background: rgba(255, 255, 255, 0.1); border: 2px solid ${color}; border-radius: 5px; color: #fff;">
                        <div style="font-size: 20px; margin-bottom: 5px;">${evo.icon} ${evo.name}</div>
                        <div style="margin-bottom: 10px;">${evo.description}</div>
                        <div style="color: ${color};">Cost: ✨ ${evo.cost}</div>
                        <button 
                            onclick="window.purchaseEvolution('${evo.id}')"
                            style="margin-top: 10px; padding: 10px 20px; background: ${canAfford ? '#00ff00' : '#666'}; border: none; border-radius: 5px; cursor: ${canAfford ? 'pointer' : 'not-allowed'}; font-weight: bold;"
                            ${!canAfford ? 'disabled' : ''}
                        >
                            ${canAfford ? 'EVOLVE' : 'NOT ENOUGH ESSENCE'}
                        </button>
                    </div>
                `;
            });
        } else {
            html += '<p style="color: #00ff00; margin-top: 20px;">You have unlocked all evolutions!</p>';
        }
        
        html += '<p style="color: #00ff00; margin-top: 30px; font-size: 18px; font-weight: bold; animation: pulse 1s infinite; text-align: center;">Press ESC to close and resume playing</p>';
        
        this.shopModal.innerHTML = html;
    }
    
    update() {
        // Update health bar
        const healthPercent = (this.player.health / this.player.maxHealth) * 100;
        this.healthBar.style.width = healthPercent + '%';
        
        // Update lives counter
        const livesCounter = document.getElementById('lives-counter');
        if (livesCounter) {
            livesCounter.textContent = '❤️'.repeat(Math.max(0, this.player.lives));
        }
        
        // Update essence counter
        this.essenceCounter.textContent = `✨ Essence: ${this.player.essence}`;
        
        // Update boss health bar if boss is active
        if (this.game && this.game.bossManager && this.game.bossManager.currentBoss) {
            const boss = this.game.bossManager.currentBoss;
            if (!boss.isDead) {
                this.showBossHealthBar(boss.name, boss.health, boss.maxHealth);
            } else {
                this.hideBossHealthBar();
            }
        } else {
            this.hideBossHealthBar();
        }
        
        // Update evolution panel - show available upgrades
        const evolutionPanel = document.getElementById('evolution-panel');
        const available = this.evolutionSystem.getAvailableEvolutions();
        
        if (available.length === 0) {
            // Hide panel when no upgrades available
            if (evolutionPanel) evolutionPanel.style.display = 'none';
        } else {
            // Show panel with affordable upgrades
            if (evolutionPanel) evolutionPanel.style.display = 'block';
            
            const affordable = available.filter(evo => this.player.essence >= evo.cost);
            
            if (affordable.length > 0) {
                // Show affordable upgrades - title and cost only
                const upgradeText = affordable.map(evo => 
                    `${evo.icon} ${evo.name}: ${evo.cost}✨`
                ).join(' | ');
                this.evolutionInfo.innerHTML = `
                    <div style="font-size: 14px; color: #00ff00; font-weight: bold;">
                        ${upgradeText}
                    </div>
                    <div style="font-size: 11px; color: #ffff00; margin-top: 3px;">
                        Press T for full details
                    </div>
                `;
            } else {
                // Show what's coming next
                const next = available[0];
                this.evolutionInfo.innerHTML = `
                    <div style="font-size: 14px; color: #888;">
                        Next: ${next.icon} ${next.name} (${next.cost}✨)
                    </div>
                    <div style="font-size: 11px; color: #666; margin-top: 3px;">
                        Need ${next.cost - this.player.essence} more essence
                    </div>
                `;
            }
        }
        
        // Update ability boxes
        if (this.player.traits.tentacles) {
            this.abilityQName.textContent = '🦑 Tentacles';
            this.abilityQDesc.textContent = 'Grab enemies';
        } else {
            this.abilityQName.textContent = '-';
            this.abilityQDesc.textContent = 'No ability';
        }
        
        if (this.player.traits.wings) {
            this.abilityEName.textContent = '🦅 Wings';
            this.abilityEDesc.textContent = 'Boost jump';
        } else {
            this.abilityEName.textContent = '-';
            this.abilityEDesc.textContent = 'No ability';
        }
        
        // Update kill counter
        if (this.game && this.game.bossManager) {
            const kills = this.game.bossManager.totalKills;
            const nextBossKills = this.game.bossManager.getNextBossKills();
            
            this.killCountElement.textContent = kills;
            
            if (nextBossKills !== null) {
                this.nextBossElement.textContent = `Next Boss: ${nextBossKills}`;
                this.nextBossElement.style.color = '#ffff00';
            } else {
                this.nextBossElement.textContent = 'All Bosses Spawned!';
                this.nextBossElement.style.color = '#00ff00';
            }
        }
        
        // Check if player can afford any evolution
        if (!this.hasShownReadyNotification) {
            const available = this.evolutionSystem.getAvailableEvolutions();
            const canAfford = available.some(evo => this.player.essence >= evo.cost);
            
            if (canAfford) {
                this.showReadyToEvolve();
            }
        }
    }
    
    showCombo(comboText, killCount) {
        // DON'T show combo if boss taunt is active (they overlap at top: 30%)
        const existingTaunts = document.querySelectorAll('div[style*="position: fixed"][style*="top: 30%"]');
        const hasBossTaunt = Array.from(existingTaunts).some(el => 
            el.textContent && !el.classList.contains('combo-notification')
        );
        
        if (hasBossTaunt) {
            return; // Skip combo notification when boss is taunting
        }
        
        // Dismiss any existing combo notifications
        const existingCombos = document.querySelectorAll('.combo-notification');
        existingCombos.forEach(combo => {
            combo.remove();
        });
        
        // Create combo notification
        const comboNotif = document.createElement('div');
        comboNotif.className = 'combo-notification';
        comboNotif.style.cssText = `
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Courier New', monospace;
            font-size: 64px;
            font-weight: bold;
            color: #ff0000;
            text-shadow: 0 0 20px #ff0000, 0 0 40px #ff0000, 0 0 60px #ff0000;
            z-index: 1000;
            pointer-events: none;
            animation: comboPopIn 0.3s ease-out;
        `;
        
        // Combo colors based on level
        let color = '#ffff00'; // Double (yellow)
        if (killCount >= 4) color = '#ff00ff'; // Rampage (magenta)
        else if (killCount >= 3) color = '#ff0000'; // Ultra (red)
        else if (killCount >= 2) color = '#ff8800'; // Mega (orange)
        
        comboNotif.style.color = color;
        comboNotif.style.textShadow = `0 0 20px ${color}, 0 0 40px ${color}, 0 0 60px ${color}`;
        comboNotif.textContent = `${comboText} ${killCount}x`; // Show multiplier!
        
        // Add animation style if not exists
        if (!document.getElementById('combo-animation-style')) {
            const style = document.createElement('style');
            style.id = 'combo-animation-style';
            style.textContent = `
                @keyframes comboPopIn {
                    0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
                    50% { transform: translate(-50%, -50%) scale(1.3); opacity: 1; }
                    100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                }
                @keyframes comboFadeOut {
                    0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                    100% { transform: translate(-50%, -50%) scale(1.5); opacity: 0; }
                }
            `;
            document.head.appendChild(style);
        }
        
        document.body.appendChild(comboNotif);
        
        // Fade out and remove
        setTimeout(() => {
            comboNotif.style.animation = 'comboFadeOut 0.5s ease-out';
            setTimeout(() => {
                if (comboNotif.parentNode === document.body) {
                    document.body.removeChild(comboNotif);
                }
            }, 500);
        }, 2000);
    }
    
    showBossHealthBar(bossName, health, maxHealth) {
        if (!this.bossHealthContainer) return;
        
        this.bossHealthContainer.style.display = 'block';
        this.bossName.textContent = bossName;
        
        const healthPercent = (health / maxHealth) * 100;
        this.bossHealthFill.style.width = `${healthPercent}%`;
    }
    
    updateBossHealth(health, maxHealth) {
        if (!this.bossHealthFill) return;
        
        const healthPercent = (health / maxHealth) * 100;
        this.bossHealthFill.style.width = `${healthPercent}%`;
    }
    
    hideBossHealthBar() {
        if (!this.bossHealthContainer) return;
        this.bossHealthContainer.style.display = 'none';
    }
}

// Global function for shop buttons
window.purchaseEvolution = function(evolutionId) {
    // This will be called from the shop HTML buttons
    console.log('Purchase requested:', evolutionId);
    // The game instance will handle this through the evolution system
};
